document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('hubspot-modal');
    const closeBtn = document.querySelector('.close-modal');
    const formContainer = document.getElementById('form-container');
    let hubspotLoaded = false;
    
    // Get all buttons with the open-modal-btn class
    const openButtons = document.querySelectorAll('.open-modal-btn');
    
    // Open modal function
    function openModal() {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Only load HubSpot once
      if (!hubspotLoaded) {
        loadHubspotForm();
        hubspotLoaded = true;
      }
    }
    
    // Close modal function
    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
    
    // Load HubSpot form
    function loadHubspotForm() {
      const hubspotDiv = document.createElement('div');
      hubspotDiv.className = 'hs-form-frame';
      hubspotDiv.setAttribute('data-region', 'eu1');
      hubspotDiv.setAttribute('data-form-id', '02a1625f-463a-4366-ae85-b0744ce9fc40');
      hubspotDiv.setAttribute('data-portal-id', '146015246');
      
      formContainer.innerHTML = '';
      formContainer.appendChild(hubspotDiv);
      
      const script = document.createElement('script');
      script.src = 'https://js-eu1.hsforms.net/forms/embed/146015246.js';
      
      script.onload = function() {
        console.log('HubSpot form loaded successfully');
      };
      
      script.onerror = function() {
        formContainer.innerHTML = '<p>Hi. Error loading form. Please try again.</p>';
      };
      
      document.body.appendChild(script);
    }
    
    // Add event listeners to all open buttons
    openButtons.forEach(button => {
      button.addEventListener('click', openModal);
    });
    
    closeBtn.addEventListener('click', closeModal);
    
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeModal();
      }
    });
  });